import { useSearch } from "wouter";
import { Seo } from "@/components/Seo";
import { Section, PageHeader } from "@/components/Section";
import { LegalProse } from "@/components/LegalProse";
import {
  CURRENT_LEGAL_VERSION,
  getLegalVersion,
  listLegalVersions,
} from "./versions";

export default function Privacy() {
  const search = useSearch();
  const requested = new URLSearchParams(search).get("v");
  const { entry, isCurrent, isKnown } = getLegalVersion(requested);
  const Body = entry.Privacy;
  const path = isCurrent ? "/legal/privacy" : `/legal/privacy?v=${entry.version}`;
  const lede = isCurrent
    ? `Last updated ${entry.lastUpdatedLabel}. This policy explains how FortifyID handles personal information in line with the Privacy Act 1988 (Cth) and the Australian Privacy Principles.`
    : `Archived version published ${entry.lastUpdatedLabel}. This is a historical copy preserved for clients who accepted this version. The current Privacy Policy is at /legal/privacy.`;

  return (
    <>
      <Seo
        title={isCurrent ? "Privacy Policy" : `Privacy Policy (${entry.version})`}
        description="How FortifyID collects, uses, stores and protects personal information."
        path={path}
      />
      <Section>
        <PageHeader
          eyebrow={
            isCurrent
              ? "Legal · Privacy Policy"
              : `Legal · Privacy Policy · Archived ${entry.version}`
          }
          title="Privacy Policy"
          lede={lede}
        />
        <LegalProse>
          {requested && !isKnown ? (
            <p>
              <em>
                The Privacy Policy version <code>{requested}</code> is not in
                our archive. Showing the current version (
                {CURRENT_LEGAL_VERSION}) instead.
              </em>
            </p>
          ) : null}
          <Body />
          <hr />
          <p className="text-sm">
            <strong>Version archive.</strong> Every published version of this
            Privacy Policy is preserved here so anyone who accepted an earlier
            copy can review the exact wording they agreed to:
          </p>
          <ul className="text-sm">
            {listLegalVersions().map((v) => (
              <li key={v.version}>
                <a href={`/legal/privacy?v=${v.version}`}>
                  {v.version} — published {v.lastUpdatedLabel}
                </a>
                {v.version === CURRENT_LEGAL_VERSION ? " (current)" : null}
              </li>
            ))}
          </ul>
        </LegalProse>
      </Section>
    </>
  );
}
